import { displayToastError, http } from 'app';
import { IFeedback } from 'app/utils';

export const sendFeedback = async (body: IFeedback): Promise<any> => {
  try {
    const response = await http.post('/portal/feedback', body);
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Send Feedback');
  }
};
